import { useEffect } from 'react';
import { useNotificationStream } from '../hooks/useNotificationStream';
import { useStreamNotificationStore } from '../stores/useStreamNotificationStore';
import { useProgressStore } from '../stores/useProgressStore';
import { useNotificationStore } from '../../../stores/notifications';

export const NotificationStreamProvider = () => {
  const { addNotification: addStreamNotification } = useStreamNotificationStore();
  const { addNotification } = useNotificationStore();
  const { addOrUpdate: addProgressNotification, remove: removeProgressNotification } =
    useProgressStore();
  const { notification } = useNotificationStream(true);

  useEffect(() => {
    if (!notification) return;

    const notificationsArray = Array.isArray(notification) ? notification : [notification];

    notificationsArray.forEach((n) => {
      // Handle budget exhausted notifications
      if (n?.type?.includes('pod_budget')) {
        addNotification({
          type: n?.level,
          title: n.title,
          message: n.message,
          delay: 10000,
        });
        return;
      }

      const progressMatch = n?.message?.match(/(\d+\.?\d*)%/);
      if (progressMatch) {
        const fileId = n?.data?.file_id;
        const modelMatch = n?.message?.match(/Model upload progress for (.*?):/);
        const modelName = modelMatch ? modelMatch[1] : 'unknown';
        const progressId = fileId ? `model_upload_${fileId}` : `model_upload_${modelName}`;
        const progress = parseFloat(progressMatch[1]);
        addProgressNotification(progressId, n?.title, n?.message, progress);
      } else {
        // Handle failure notifications
        if (n?.type === 'model_upload' && n?.title === 'Model Upload Failed' && n?.data?.file_id) {
          const fileId = n.data.file_id;
          const progressId = `model_upload_${fileId}`;
          removeProgressNotification(progressId);
        }

        if (!n?._id) return;
        const transformedNotification = {
          id: n?._id,
          message: n?.message,
          read: false,
          created_at: n?.created_at,
        };
        addStreamNotification(transformedNotification);
      }
    });
  }, [notification]);

  return null;
};
